import HeaderCTA from "./HeaderCTA";

function Header() {
    return (
        <header>
            <HeaderCTA />
        </header>
    )
}

export default Header;